export const REDEN_VAN_STATUS_IN_AANMAAK = "1";
export const REDEN_VAN_STATUS_INACTIEF = "2";
export const REDEN_VAN_STATUS_INGEDIEND = "121450000";
export const REDEN_VAN_STATUS_VOLLEDIG_AFGESLOTEN = "121450001";

export const ALGEMENE_STATUS_NOG_NIET_INGEDIEND = 121450000;
export const ALGEMENE_STATUS_IN_BEHANDELING = 121450001;
export const ALGEMENE_STATUS_GESELECTEERD = 121450002;
export const ALGEMENE_STATUS_NIET_GESELECTEERD = 121450003;
export const ALGEMENE_STATUS_VOLLEDIG_AFGESLOTEN = 121450004;

export const DOSSIER_TYPE_AANVRAAG_BOVENLOKAAL_NIEUWBOUW = 121450000;
export const DOSSIER_TYPE_AANVRAAG_BOVENLOKAAL_RENOVATIE = 121450001;
export const DOSSIER_TYPE_AANVRAAG_TOPSPORT_NIEUWBOUW = 121450003;
export const DOSSIER_TYPE_AANVRAAG_TOPSPORT_RENOVATIE = 121450004;
export const DOSSIER_TYPE_NEW_SIMULATIE = 0;

export const DOSSIER_SOORT_NIEUWBOUW = 121450000;
export const DOSSIER_SOORT_RENOVATIE = 121450001;
export const DOSSIER_SOORT_NIEUWBOUWRENOVATIE = 121450002;

export const INVESTERING_TYPE_SPORTGERELATEERD = 121450000;

export const HAS_CONCURRENCY_EXCEPTION = "HAS_CONCURRENCY_EXCEPTION";
export const HAS_VALIDATION_ERRORS_SAVED = "HAS_VALIDATION_ERRORS_SAVED";
export const HAS_VALIDATION_ERRORS = "HAS_VALIDATION_ERRORS";
export const HAS_FILE_EXCEPTION = "HAS_FILE_EXCEPTION";
export const SUCCESS = "SUCCESS";
export const SUCCESS_NO_TOASTR = "SUCCESS_NO_TOASTR";
export const RAPPORT_GENEREREN = "RAPPORT_GENEREREN";
export const NO_GEOCOORDINATEN_FOUND = "NO_GEOCOORDINATES_FOUND";
export const NO_GEOCOORDINATEN_FOUND2 = "NO_GEOCOORDINATES_FOUND2";
export const PDF_GENEREREN = "PDF_GENEREREN";
export const PDF_SIMULATIE_GENEREREN = "PDF_SIMULATIE_GENEREREN";
export const HAS_VALIDATION_ERRORS_SAVED_SIMULATIE = "HAS_VALIDATION_ERRORS_SAVED_SIMULATIE";

export const SIMULATIE_TYPE_DOSSIER = "DOSSIER";
/*
export const NO_GEOCOORDINATEN_FOUND_TITLE = "Opgepast";
export const NO_GEOCOORDINATEN_FOUND = "Er zijn geen coördinaten gevonden, gelieve zelf de coördinaten in te vullen";*/

export const ANDERE_INFRASTRUCTUUR_GUID = "9689b397-716c-e711-810a-e0071b66e0e1";
export const ANDERE_DOELGROEP_ID = "121450000";
export const ANDER_JURIDISH_STATUUT_GUID = "121450018";

export const INFRASTRUCTUUR_GUID_OPENLUCHT_NATUUR = '761cf9e0-325b-e711-8107-e0071b66f051';
export const INFRASTRUCTUUR_GUID_OPENLUCHT_KUNST = '741cf9e0-325b-e711-8107-e0071b66f051';

export const DomainScopes = {
	DOSSIERINFRASTRUCTUUR: "dossierinfrastructuur",
	VOORTGANGSRAPPORT: "voortgangsrapport"
};

export const DocumentTab = {
	Aanvraag: "Aanvraag",
	Project: "Project",
	MinimaleEisen: "Minimale eisen",
	BovenLokaliteit: "Boven lokaliteit",
	Criteria: "Criteria",
	Indienen: "Indienen",
	Pdf: "PDF",
	Simulatiedossier: "Simulatiedossier",
	VRVerantwoording: "Verantwoording",
	MijnDossier: "Mijn dossier",
	FinancieelSubtabFinanciering: "FinancieelSubtabFinanciering"
};

export const ComponentName = {
	RetributieReglement: "Retributiereglement",
	VerklaringOpEer: "Verklaring op eer",
	ZakelijkRecht: "Zakelijk recht",
	Rapport: "Rapport",
	HaalbaarheidsRapport: "HaalbaarheidsRapport",
	DuurzaamheidsRapport: "DuurzaamheidsRapport",

	Vergunning: "Vergunning",
	Engagementsverklaring: "Engagementsverklaring",

	ArchitectPlannen: "Architect plannen",
	InplantingsplanVoorDeWerken: "Inplantingsplan voor de werken",
	InplantingsplanNaDeWerken: "Inplantingsplan na de werken",
	BewijsstukkenAanbod: "Bewijsstukken aanbod",
	BewijsstukkenOntwerpenVoorIedereen: "Bewijsstukken ontwerpen voor iedereen",
	BewijsstukkenToegankelijkheid: "Bewijsstukken toegankelijkheid",
	UittrekselSamenwerkingsbeslissing: "UittrekselSamenwerkingsbeslissing",
	Samenwerkingsverbanden: "Samenwerkingsverbanden",
	ImpactTopsportlandschap: "Impact topsportlandschap",
	PrioritaireBeschikkingen: "Prioritaire beschikkingen",
	Campusmodel: "Campusmodel",
	Kwaliteit: "Kwaliteit",
	Innovatie: "Innovatie",
	NieuweTechnologieen: "Nieuwe technologieen",
	Financier: "Financier",
	BewijsEigendom: "Bewijs eigendom",
	BewijsZakelijkRecht: "Bewijs zakelijk recht",
	BewijsVanFinanciering: "Bewijs van financiering",
	BewijsVanFinancieringSjabloon: 'Voorbeelddocument "Bewijs van financiering"',

	TopsportProtocol: "Topsport protocol",
	BewijsstukkenGemaakteKosten: "Bewijsstukken gemaakte kosten",
	ToelichtingGemaakteKosten: "Toelichting gemaakte kosten",
	VoorlopigOpleveringsVerslag: "Voorlopig opleveringsverslag",
	DefinitieveEpbAangifte: "Definitieve EPB aangifte",

	MinisterieelBesluit: "Ministerieel besluit",

	Gewestplan: "Gewestplan",
	BPAPlan: "BPAGrafischPlan",
	RUPPlan: "RUPGrafischPlan",
	BPAVoorwaarden: "BPAStedenbouwkundigeVoorwaarden",
	RUPVoorwaarden: "RUPStedenbouwkundigeVoorwaarden",
	
	OndertekendePDF: "ondertekende pdf"
};

export const KostenOpbrengstenInvesteringMainTypes =
{
	Bedrijfsopbrengst: "ef66bb0d-de01-e811-810f-5065f38be551",
	Bedrijfskost: "f166bb0d-de01-e811-810f-5065f38be551",
	FinanciëleOpbrengst: "f366bb0d-de01-e811-810f-5065f38be551",
	FinanciëleKost: "f566bb0d-de01-e811-810f-5065f38be551",
	UitzonderlijkeOpbrengst: "f766bb0d-de01-e811-810f-5065f38be551",
	UitzonderlijkeKost: "f966bb0d-de01-e811-810f-5065f38be551",
	VervangingsinvesteringNieuweImpuls: "fb66bb0d-de01-e811-810f-5065f38be551"
};

export const KostenSingleSubTypes =
{
	FinancieleKostSubType: "60ca0730-de01-e811-8114-5065f38ada11",
	UitzonderlijkeKostSubType: "64ca0730-de01-e811-8114-5065f38ada11"
};

export const OpbrengstenSingleSubTypes =
{
	FinancieleOpbrengstSubType: "5eca0730-de01-e811-8114-5065f38ada11",
	UitzonderlijkeOpbrengstSubType: "62ca0730-de01-e811-8114-5065f38ada11"
};

export const KostenTypes =
	[
		{
			label: 'Bedrijfskost',
			value: "f166bb0d-de01-e811-810f-5065f38be551"
		},
		{
			label: 'FinanciëleKost',
			value: "f566bb0d-de01-e811-810f-5065f38be551"
		},
		{
			label: 'UitzonderlijkeKost',
			value: "f966bb0d-de01-e811-810f-5065f38be551"
		}
	];

export const OpbrengstenTypes =
	[
		{
			label: 'Bedrijfsopbrengst',
			value: "ef66bb0d-de01-e811-810f-5065f38be551"
		},
		{
			label: 'FinanciëleOpbrengst',
			value: "f366bb0d-de01-e811-810f-5065f38be551"
		},
		{
			label: 'UitzonderlijkeOpbrengst',
			value: "f766bb0d-de01-e811-810f-5065f38be551"
		}
	];

export const FinancieelTitels =
{
	FinancieleDuurzaamheid: "Financiële duurzaamheid",
	FinancieleHaalbaarheid: "Financiële haalbaarheid"
};

export const LangdurigZakelijkRechtTypes =
{
	Andere: "Andere"
};

export const FINANCIEEL =
{
	TABLETYPE: {
		KOSTENOPBRENGSTEN: 1,
		SPORTGERELATEERD: 2,
		NIETSPORTGERELATEERD: 3,
		FINANCIERS: 4
	}
};

export const KostOpbrengst =
{
	KOST: 1,
	OPBRENGST: 2
};

export const NIET_VERANKERBAAR_SPORTMATERIAAL = 121450009;

export const INFRASTRUCTUUR_TYPE =
{
	NIEUWBOUW: 121450000,
	RENOVATIE: 121450001
};

export const DeelVanAanvraag = {
	Ja: 0,
	Nee: 1,
	Reconversie: 2
};